import { CloudUpload, DeleteOutlineOutlined } from '@mui/icons-material'
import { Autocomplete, Box, Divider, Grid, IconButton, MenuItem, Select, TextField, Typography } from '@mui/material'
import { FormikProps, FormikValues } from 'formik';
import React from 'react'
import { toast } from 'react-toastify';
import { ApiUploadFile } from '../../../../Core/Apicall';

interface Props {
    formik: FormikProps<any>;
}

function CompanyInformation({ formik }: Props) {
    const options = [
        { label: "Ducting", value: "Ducting" },
        { label: "Eeletrical", value: "Electrical" },
        { label: "Hardware", value: "Hardware" },
        { label: "trading", value: "trading" },
        { label: "texttile", value: "texttile" },
    ];

    const handleUpload = async (e: React.ChangeEvent<HTMLInputElement>) => {
        const files = Array.from(e.target.files || []);
        // if (!files.length) return;

        try {
            const formData = new FormData();

            files.forEach((file) => {
                formData.append("files", file);
            });

            formData.append("folder", "products");

            const res = await ApiUploadFile(formData);

            if (res?.status) {
                const uploadedMedia = res.data.map((item: any) => ({
                    media_url: item.fileUrl,
                    media_type: "IMAGE",
                }));

                formik.setFieldValue("companyLogo", uploadedMedia);

                // Allow selecting same file again
                e.target.value = "";
            }
        } catch (error: any) {
            toast.error(error?.message || "Something went wrong");
        }
    };


    return (
        <Box className='p-xl-5 p-md-3 p-1 mt-2 mt-md-0'>
            <Grid container spacing={2}>
                <Grid size={12}>
                    <Typography variant='h6' className='fw-bold mt-3 mt-md-0'>Company Information</Typography>
                </Grid>
                <Grid size={{ xs: 12, md: 4, xl: 3 }}>
                    <Grid container spacing={2}>
                        <Grid size={12}>
                            {formik.values.companyLogo?.[0]?.media_url ? (
                                <Box
                                    sx={{
                                        border: "2px dashed #666",
                                        borderRadius: "12px",
                                        p: 2,
                                        height: "200px",
                                        width: "250px",
                                        position: "relative",
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        overflow: "hidden",
                                    }}
                                >
                                    <img
                                        src={formik.values.companyLogo[0].media_url}
                                        alt="Company Logo"
                                        style={{
                                            width: "100%",
                                            height: "150px",
                                            objectFit: "contain",
                                        }}
                                    />

                                    {/* Change button */}
                                    <Box className='d-flex align-items-center gap-1'>
                                        <Box
                                            component="label"
                                            sx={{
                                                position: "absolute",
                                                bottom: 10,
                                                left: "50%",
                                                transform: "translateX(-50%)",
                                                cursor: "pointer",
                                                background: "var(--primary-color)",
                                                color: "#fff",
                                                px: 2,
                                                py: 0.5,
                                                borderRadius: "6px",
                                                fontSize: "13px",
                                            }}
                                        >
                                            Change

                                            <input
                                                hidden
                                                type="file"
                                                accept="image/png,image/jpeg,image/webp"
                                                onChange={handleUpload}
                                            />
                                        </Box>
                                        <IconButton className='m-0 p-0' sx={{
                                            position: "absolute",
                                            bottom: 10,
                                            left: "25%",
                                            transform: "translateX(-50%)",
                                            cursor: "pointer",
                                            px: 2,
                                            py: 0.5,
                                            borderRadius: "6px",
                                            fontSize: "13px",
                                        }} onClick={() => { formik.setFieldValue("companyLogo", null) }}>
                                            <DeleteOutlineOutlined className='text-danger' />
                                        </IconButton>
                                    </Box>

                                </Box>
                            ) : (
                                /* Upload box */
                                <Box
                                    className="d-flex flex-column align-items-center justify-content-center"
                                    sx={{
                                        border: "2px dashed #666",
                                        borderRadius: "12px",
                                        p: 4,
                                        height: "200px",
                                        width: "250px",
                                        textAlign: "center",
                                        cursor: "pointer",
                                        transition: "0.3s",
                                        "&:hover": {
                                            borderColor: "var(--primary-color)",
                                            background: "var(--primary-light-color)",
                                        },
                                    }}
                                    component="label"
                                >
                                    <input
                                        hidden
                                        type="file"
                                        // accept="image/png,image/jpeg,image/webp"
                                        accept="image/*"
                                        onChange={handleUpload}
                                    />

                                    <CloudUpload className="fs-48" />

                                    <Typography className="fs-16" gutterBottom>
                                        Click to upload image
                                    </Typography>

                                    <Typography className="text-grey fs-12">
                                        PNG, JPG, WEBP
                                    </Typography>
                                </Box>
                            )}
                        </Grid>
                    </Grid>
                </Grid>
                <Grid size={{ xs: 12, md: 8, xl: 9 }} className='form-text-field'>
                    <Grid container spacing={1.5}>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Company Name</Typography>
                            <TextField
                                name='companyName'
                                fullWidth
                                placeholder='Enter company name'
                                value={formik.values.companyName}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.companyName &&
                                    Boolean(formik.errors.companyName)
                                }
                                helperText={
                                    formik.touched.companyName
                                        ? (formik.errors.companyName as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Business Type</Typography>
                            <TextField
                                name='businessType'
                                fullWidth
                                placeholder='Enter business type'
                                value={formik.values.businessType}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.businessType &&
                                    Boolean(formik.errors.businessType)
                                }
                                helperText={
                                    formik.touched.businessType
                                        ? (formik.errors.businessType as string)
                                        : ""
                                }
                            />

                        </Grid>

                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Company Email</Typography>
                            <TextField
                                name='companyEmail'
                                fullWidth
                                type='email'
                                placeholder='Enter email address'
                                value={formik.values.companyEmail}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.companyEmail &&
                                    Boolean(formik.errors.companyEmail)
                                }
                                helperText={
                                    formik.touched.companyEmail
                                        ? (formik.errors.companyEmail as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Company Phone</Typography>
                            <TextField
                                name='companyPhone'
                                fullWidth
                                type="tel"
                                placeholder='Enter phone number'
                                value={formik.values.companyPhone}
                                onChange={(e) => {
                                    const numbersOnly = e.target.value
                                        .replace(/\D/g, "")
                                        .slice(0, 10);

                                    formik.setFieldValue("companyPhone", numbersOnly);
                                }}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.companyPhone &&
                                    Boolean(formik.errors.companyPhone)
                                }
                                helperText={
                                    formik.touched.companyPhone
                                        ? (formik.errors.companyPhone as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold' variant='body2' gutterBottom>Website</Typography>
                            <TextField
                                name='website'
                                fullWidth
                                placeholder='Enter website URL'
                                value={formik.values.website}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.website &&
                                    Boolean(formik.errors.website)
                                }
                                helperText={
                                    formik.touched.website
                                        ? (formik.errors.website as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>GST Number</Typography>
                            <TextField
                                name='gstNumber'
                                fullWidth
                                placeholder='Enter gst number'
                                value={formik.values.gstNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.gstNumber &&
                                    Boolean(formik.errors.gstNumber)
                                }
                                helperText={
                                    formik.touched.gstNumber
                                        ? (formik.errors.gstNumber as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>PAN Number</Typography>
                            <TextField
                                name='panNumber'
                                fullWidth
                                placeholder='Enter pan number'
                                value={formik.values.panNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.panNumber &&
                                    Boolean(formik.errors.panNumber)
                                }
                                helperText={
                                    formik.touched.panNumber
                                        ? (formik.errors.panNumber as string)
                                        : ""
                                }
                            />

                        </Grid>
                        <Grid size={{ xs: 12, md: 6 }}>
                            <Typography className='fw-bold input-label' variant='body2' gutterBottom>Registration Number</Typography>
                            <TextField
                                name='registrationNumber'
                                fullWidth
                                placeholder='Enter registartion number'
                                value={formik.values.registrationNumber}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                error={
                                    formik.touched.registrationNumber &&
                                    Boolean(formik.errors.registrationNumber)
                                }
                                helperText={
                                    formik.touched.registrationNumber
                                        ? (formik.errors.registrationNumber as string)
                                        : ""
                                }
                            />
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
            <Divider className='my-4' />
            <Typography variant='h6' className='fw-bold' gutterBottom>Address</Typography>
            <Grid container spacing={1.5} className='form-text-field'>
                <Grid size={{ xs: 12 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Address Line1</Typography>
                    <TextField
                        fullWidth
                        name='addressLine1'
                        placeholder='Enter address'
                        value={formik.values.addressLine1}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.addressLine1 &&
                            Boolean(formik.errors.addressLine1)
                        }
                        helperText={
                            formik.touched.addressLine1
                                ? (formik.errors.addressLine1 as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>City</Typography>
                    <TextField
                        name='city'
                        fullWidth
                        placeholder='Enter City'
                        value={formik.values.city}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.city &&
                            Boolean(formik.errors.city)
                        }
                        helperText={
                            formik.touched.city
                                ? (formik.errors.city as string)
                                : ""
                        }
                    />
                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>State</Typography>
                    <TextField
                        fullWidth
                        name='state'
                        placeholder='Enter State'
                        value={formik.values.state}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.state &&
                            Boolean(formik.errors.state)
                        }
                        helperText={
                            formik.touched.state
                                ? (formik.errors.state as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Country</Typography>
                    <TextField
                        fullWidth
                        name='country'
                        placeholder='Enter country'
                        value={formik.values.country}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.country &&
                            Boolean(formik.errors.country)
                        }
                        helperText={
                            formik.touched.country
                                ? (formik.errors.country as string)
                                : ""
                        }
                    />

                </Grid>
                <Grid size={{ xs: 12, md: 3 }}>
                    <Typography className='fw-bold input-label' variant='body2' gutterBottom>Postal Code</Typography>
                    <TextField
                        fullWidth
                        name='postalCode'
                        placeholder='Enter Postal Code'
                        value={formik.values.postalCode}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        error={
                            formik.touched.postalCode &&
                            Boolean(formik.errors.postalCode)
                        }
                        helperText={
                            formik.touched.postalCode
                                ? (formik.errors.postalCode as string)
                                : ""
                        }
                    />

                </Grid>
            </Grid>
        </Box>
    )
}

export default CompanyInformation
